import React, { useContext } from 'react';
import * as _ from 'lodash';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import AutocodeSelectionContext from '../ACContext/ACSelectionBoxContext';
import {
  AC_NODETYPE_ROOT,
  AC_NODETYPE_OPERATOR,
  AC_NODETYPE_DATAPOINT,
  AC_NODETYPE_DEFINITION,
  AC_NODETYPE_FUNC,
} from '../AutocodeConstants';
import { getShowTimePeriod } from '../AutocodeFunctions';

const EndPoint = props => {
  const { node, partsToShow: pts, showAFlag, showTimePeriod } = props;

  switch (node.type) {
    case AC_NODETYPE_DEFINITION:
      return <span value={node.id}>{`${node.data.title}`}</span>;
    case AC_NODETYPE_DATAPOINT: {
      let q = '';
      let a = '';
      let cat = '';
      let subCats = '';

      if (node.data.labels) {
        if (node.data.labels.length === 0) {
          // should never happen
          q = 'error';
          a = 'error';
          cat = 'error';
        } else if (node.data.labels.length === 1) {
          // a = getAnswerForLevel(node.data, 0, showTimePeriod);
          a = node.data.labels[0];
        } else if (node.data.labels.length === 2) {
          q = node.data.labels[0];
          // a = getAnswerForLevel(node.data, 1, showTimePeriod);
          a = node.data.labels[1];
        } else if (node.data.labels.length === 3) {
          cat = node.data.labels[0];
          q = node.data.labels[1];
          // a = getAnswerForLevel(node.data, 2, showTimePeriod);
          a = node.data.labels[2];
        } else {
          // drop the superCat, the question and answer
          const cats = _.dropRight(_.drop(node.data.labels, 1), 2);
          cat = pts.showCat ? cats[0] : '';

          if (cats.length >= 2) {
            subCats = pts.showSCats
              ? _.join(_.drop(_.split(cats, ',')), '/')
              : '';
          }
          q = node.data.labels[node.data.labels.length - 2];
          // a = getAnswerForLevel(
          //   node.data,
          //   node.data.labels.length - 1,
          //   showTimePeriod
          // );
          a = node.data.labels[node.data.labels.length - 1];
        }
      }

      let outstr = pts.showCat ? cat : '';
      let lastCharIsSpecialCharFlag = false;
      if (outstr.length > 0) {
        outstr += ': ';
        lastCharIsSpecialCharFlag = true;
      } else {
        outstr += '';
      }
      outstr += subCats;
      lastCharIsSpecialCharFlag =
        pts.showSCats && subCats.length > 0 ? false : lastCharIsSpecialCharFlag;

      if (!lastCharIsSpecialCharFlag && pts.showQ && outstr.length > 0) {
        outstr += '/ ';
        lastCharIsSpecialCharFlag = true;
      } else {
        outstr += '';
      }
      outstr += pts.showQ ? q : '';
      lastCharIsSpecialCharFlag =
        pts.showQ && q.length > 0 ? false : lastCharIsSpecialCharFlag;
      outstr +=
        !lastCharIsSpecialCharFlag && outstr.length > 0 && pts.showA ? '_' : '';
      outstr += pts.showA ? a : '';

      if (showAFlag === undefined && subCats.length === 0) {
        outstr = outstr.length === 0 ? a : outstr; // if the string contains no text then display answer
      }

      return (
        <span data-test="EndPoint" value={node.id}>
          {outstr}
        </span>
      );
    }
    default:
      return <span>error</span>;
  }
};

EndPoint.propTypes = {
  showAFlag: PropTypes.bool,
  node: PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.string,
    data: PropTypes.shape({
      labels: PropTypes.arrayOf(PropTypes.string),
      title: PropTypes.string,
      template: PropTypes.string,
    }),
  }),
  partsToShow: PropTypes.shape({
    showCat: PropTypes.bool,
    showSCats: PropTypes.bool,
    showQ: PropTypes.bool,
    showA: PropTypes.bool,
  }),
  showTimePeriod: PropTypes.bool,
};

// ************************************************************************************************
export const ACEndPointBlock = props => {
  const { node, defParts, showTimePeriod, handleMouseOver, handleMouseUp } = props;

  return (
    <span
      onMouseDown={e => handleMouseOver(e, node)}
      onMouseUp={e => handleMouseUp(e, node)}
    >
      <EndPoint
        data-test="ACEndPointBlock"
        node={node}
        partsToShow={defParts}
        showTimePeriod={showTimePeriod}
      />
    </span>
  );
};

ACEndPointBlock.propTypes = {
  defParts: PropTypes.shape({}),
  handleClick: PropTypes.func,
  node: PropTypes.shape({
    id: PropTypes.string,
  }),
  handleMouseOver: PropTypes.func,
  showTimePeriod: PropTypes.bool,
};

// ************************************************************************************************
export const ACDefinitionBlock = props => {
  const { node, handleMouseUp, handleMouseOver } = props;

  return (
    <div
      data-test="ACDefinitionBlock"
      onMouseDown={e => handleMouseOver(e, node)}
      onMouseUp={e => handleMouseUp(e, node)}
      value={node.id}
    >{`${node.data.title}`}</div>
  );
};

ACDefinitionBlock.propTypes = {
  handleMouseUp: PropTypes.func,
  handleMouseOver: PropTypes.func,
  node: PropTypes.shape({
    id: PropTypes.string,
    selected: PropTypes.bool,
    data: PropTypes.shape({
      title: PropTypes.string,
      template: PropTypes.string,
    }),
  }),
};

// ************************************************************************************************
export const ACOperator = props => {
  const { node, handleOpClick } = props;

  const acSelContext = useContext(AutocodeSelectionContext);

  const isTopNode = () => {
    const isTop =
      _.isUndefined(
        _.find(acSelContext.state.topLevelOpNodes, n => n.id === node.id)
      ) === false;
    return isTop;
  };

  return !isTopNode() ? (
    <span
      data-test="ACOperator"
      value={node.id}
      className="ac-selectionbox-item-box-item-operator-inner"
    >{` ${node.data.type.label} `}</span>
  ) : (
    <span
      data-test="ACOperator"
      value={node.id}
      className={classNames('ac-selectionbox-item-box-item-operator-root', {
        'ac-selectionbox-item-box-item-operator-selected': node.data.selected,
        'ac-selectionbox-item-box-item-operator-break': !node.combine(),
      })}
      onClick={e => {
        handleOpClick(e, node);
        e.stopPropagation();
      }}
    >{` ${node.data.type.label} `}</span>
  );
};

ACOperator.propTypes = {
  node: PropTypes.shape({
    combine: PropTypes.func,
    id: PropTypes.string,
    selected: PropTypes.bool,
    data: PropTypes.shape({
      isTop: PropTypes.bool,
      template: PropTypes.string,
      selected: PropTypes.bool,
      type: PropTypes.shape({
        label: PropTypes.string,
      }),
    }),
  }),
  handleOpClick: PropTypes.func,
};

// ************************************************************************************************
export const ACOperatorBlock = props => {
  const {
    rootNode,
    drawNodeHeirarchy,
    handleOpClick,
    defParts,
    showTimePeriod,
    handleMouseOver,
    handleMouseUp,
  } = props;

  // traverse down until a datapoint is found the question
  const drawNodeQuestion = innerNode => {
    let showAFlag = false;
    if (
      !defParts.showCat &&
      !defParts.showQ &&
      defParts.showA &&
      defParts.showSCats
    ) {
      showAFlag = defParts.showA;
      // console.log('showAFlag => ', showAFlag);
    }
    return innerNode.type === AC_NODETYPE_DATAPOINT ? (
      <EndPoint
        node={innerNode}
        partsToShow={{
          showCat: defParts.showCat,
          showSCats: defParts.showSCats,
          showQ: defParts.showQ,
          showA: false,
        }}
        showAFlag={showAFlag}
        showTimePeriod={showTimePeriod}
      />
    ) : (
      drawNodeQuestion(innerNode.children[0])
    );
  };

  const drawMergedNode = innerNode => {
    const drawNodesMerged = innerNode => {
      if (innerNode.type === AC_NODETYPE_OPERATOR) {
        return (
          <React.Fragment>
            {drawNodesMerged(innerNode.children[0])}
            <ACOperator node={innerNode} handleOpClick={handleOpClick} />
            {drawNodesMerged(innerNode.children[1])}
          </React.Fragment>
        );
      }

      // else (implied)
      return (
        <EndPoint
          node={innerNode}
          partsToShow={{
            showCat: false,
            showSCats: false,
            showQ: false,
            showA: true,
          }}
          showTimePeriod={showTimePeriod}
        />
      );
    };

    return (
      <span>
        {innerNode.rootnodeChild !== AC_NODETYPE_ROOT && (
          <span className="ac-selectionbox-item-box-item-parens">{` ( `}</span>
        )}
        {drawNodeQuestion(innerNode.children[0])}
        <span className="ac-selectionbox-item-box-item-parens">{` ( `}</span>
        {drawNodesMerged(innerNode)}
        <span className="ac-selectionbox-item-box-item-parens">{` ) `}</span>
        {innerNode.rootnodeChild !== AC_NODETYPE_ROOT && (
          <span className="ac-selectionbox-item-box-item-parens">{` ) `}</span>
        )}
      </span>
    );
  };

  const drawNodesIndividually = (innerNode, defParts) => {
    switch (innerNode.type) {
      case AC_NODETYPE_OPERATOR: {
        if (innerNode.combine() === false) {
          return (
            <React.Fragment>
              {drawNodesIndividually(innerNode.children[0], defParts)}
              <ACOperator node={innerNode} handleOpClick={handleOpClick} />
              {drawNodesIndividually(innerNode.children[1], defParts)}
            </React.Fragment>
          );
        }
        return <React.Fragment>{drawMergedNode(innerNode)}</React.Fragment>;
      }
      case AC_NODETYPE_FUNC: {
        return drawNodeHeirarchy(innerNode, false, false);
      }
      default: {
        return (
          <React.Fragment>
            <span className="ac-selectionbox-item-box-item-parens">{` ( `}</span>
            <EndPoint
              node={innerNode}
              partsToShow={defParts}
              showTimePeriod={showTimePeriod}
            />
            <span className="ac-selectionbox-item-box-item-parens">{` ) `}</span>
          </React.Fragment>
        );
      }
    }
  };

  const drawOperatorNode = node => {
    const outerParensNeeded = !node.combine();
    if (!outerParensNeeded === true) {
      return (
        <div
          data-test="ACOperatorBlock"
          onMouseDown={e => handleMouseOver(e, node)}
          onMouseUp={e => handleMouseUp(e, node)}
        >
          {drawMergedNode(node)}
        </div>
      );
    }

    return (
      <div
        data-test="ACOperatorBlock"
        onMouseDown={e => handleMouseOver(e, rootNode)}
        onMouseUp={e => handleMouseUp(e, rootNode)}
      >
        {outerParensNeeded && (
          <div
            className="ac-selectionbox-item-box-item-parens"
            style={{ fontSize: '16px' }}
          >{`( `}</div>
        )}
        <div className="ac-selectionbox-inner-block">
          {drawNodesIndividually(node, defParts)}
        </div>
        {outerParensNeeded && (
          <div
            className="ac-selectionbox-item-box-item-parens"
            style={{ fontSize: '16px' }}
          >{` )`}</div>
        )}
      </div>
    );
  };

  return drawOperatorNode(rootNode);
};

ACOperatorBlock.propTypes = {
  drawNodeHeirarchy: PropTypes.func,
  handleClick: PropTypes.func,
  node: PropTypes.shape({
    type: PropTypes.string,
  }),
  showTimePeriod: PropTypes.bool,
};

export const ACFunctionBlock = props => {
  const { node, drawNodeHeirarchy, handleMouseOver, handleMouseUp, handleFuncClick } = props;

  // Show time period in data point labels under certain functions
  const showTimePeriod = getShowTimePeriod(node.data.funcName);

  const drawFunction = node => {
    return node.data.editable && node.rootnodeChild === AC_NODETYPE_ROOT ? (
      <span
        data-test="ACFunction"
        value={node.id}
        className={classNames('ac-selectionbox-item-box-item-operator-root', {
          'ac-selectionbox-item-box-item-operator-selected': node.data.selected,
        })}
        onClick={e => {
          handleFuncClick(e, node);
          e.stopPropagation();
        }}
      >{` ${node.data.funcName} `}</span>
    ) : (
      <span
        data-test="ACFunction"
        value={node.id}
        className="ac-selectionbox-item-box-item-operator-inner"
      >{` ${node.data.funcName} `}</span>
    );
  };

  const drawSuffix = node => {
    switch (_.upperCase(node.data.funcName)) {
      default:
        return <React.Fragment />;
      case 'COUNT': {
        return (
          <span className="ac-selectionbox-item-box-item-operator-inner">
            {`; ${node.data.params.lower}-${node.data.params.upper}`}
          </span>
        );
      }
    }
  };

  return (
    <div
      onMouseDown={e => handleMouseOver(e, node)}
      onMouseUp={e => handleMouseUp(e, node)}
    >
      {drawFunction(node)}
      <span className="ac-selectionbox-item-box-item-parens">{` ( `}</span>
      {node.children.map((n, i) =>
        drawNodeHeirarchy(
          n,
          false,
          i < node.children.length - 1,
          showTimePeriod
        )
      )}
      {drawSuffix(node)}
      <span className="ac-selectionbox-item-box-item-parens">{` ) `}</span>
    </div>
  );
};

ACFunctionBlock.propTypes = {
  drawNodeHeirarchy: PropTypes.func,
  node: PropTypes.shape({
    children: PropTypes.arrayOf(PropTypes.shape({})),
    combine: PropTypes.func,
    rootnodeChild: PropTypes.string,
    id: PropTypes.string,
    data: PropTypes.shape({
      selected: PropTypes.bool,
      funcName: PropTypes.string,
      editable: PropTypes.bool,
      template: PropTypes.string,
      params: PropTypes.shape({
        lower: PropTypes.string,
        upper: PropTypes.string,
      }),
    }),
  }),
  handleMouseUp: PropTypes.func,
  handleMouseOver: PropTypes.func,
};
